import React, { useEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useElementDimensions } from "@sportal/cdk";

import { Mobile, NotMobile } from "../../common/Responsive";
import { ReportProvider, useReportContext } from "../barchart/ReportProvider";
import { isReportsLoading, loadReports } from "../../store/reports";
import { ReportMobile } from "./ReportMobile";
import { ReportNotMobile } from "./ReportNotMobile";
import {
  LocalLoader,
  LocalLoaderWrapper,
} from "../loader/localLoader/LocalLoader";
import { getIsLoaderShown } from "../../store/loader";

import "./Report.scss";

const ReportComponent = ({ profileName }) => {
  const dispatch = useDispatch();
  const { duration, reports } = useReportContext();

  useEffect(() => {
    dispatch(loadReports(reports, duration, profileName), {
      showLoader: false,
    });
  }, [duration]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <Mobile>
        <ReportMobile profileName={profileName} />
      </Mobile>
      <NotMobile>
        <ReportNotMobile profileName={profileName} />
      </NotMobile>
    </Fragment>
  );
};

export const Report = (props) => {
  const container = useRef(null);

  const { width } = useElementDimensions(container);
  const isLoading = useSelector(isReportsLoading);
  const isGlobalLoaderShown = useSelector(getIsLoaderShown);

  return (
    <LocalLoaderWrapper>
      <div className={"report"}>
        {!isGlobalLoaderShown && isLoading && <LocalLoader />}
        <div className={"report__container"}>
          <div className={"report__container--inner"} ref={container}>
            <ReportProvider containerWidth={width}>
              <ReportComponent {...props} />
            </ReportProvider>
          </div>
        </div>
      </div>
    </LocalLoaderWrapper>
  );
};
